<app-breadcrumb [title]="'Digitales PESV'" [items]="['Pesv']" [active_item]="'Digitales'"></app-breadcrumb>

<div class="container-fluid py-4">
  <div class="row">
    <!-- Cards dinámicos desde configuración digitales_pesv -->
    <div class="col-md-4 mb-4" *ngFor="let archivo of archivos">
      <div class="card shadow-sm rounded h-100 d-flex flex-column">
        <div class="card-header bg-primary text-white text-center fw-bold">
          {{ archivo.nombre | uppercase }}
        </div>

        <div class="card-body d-flex flex-column align-items-center justify-content-center">
          <input
            type="file"
            class="d-none"
            (change)="onFileChangeCard($event, archivo)"
            [id]="'fileInputPesv' + archivo.id"
            [attr.accept]="getAccept(archivo)"
            aria-label="Subir archivo {{ archivo.nombre }}"
          />

          <label
            [for]="'fileInputPesv' + archivo.id"
            class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer"
            tabindex="0"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDropCard($event, archivo)"
          >
            <ng-container *ngIf="archivo.file; else noFilePesv">
              <i class="icofont icofont-file-word fs-1 text-primary mb-2"></i>
              <small class="text-primary text-truncate" [title]="archivo.file?.name">
                {{ archivo.file?.name }}
              </small>
            </ng-container>

            <ng-template #noFilePesv>
              <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
              <p class="mb-0 fw-semibold text-primary text-center">
                Haz click o arrastra para cargar
              </p>
            </ng-template>
          </label>
        </div>

        <div
          *ngIf="archivo.estado === 'subiendo'"
          class="progress my-2 mx-3"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          [attr.aria-valuenow]="archivo.progreso"
        >
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            [style.width.%]="archivo.progreso"
          >
            {{ archivo.progreso }}%
          </div>
        </div>

        <div
          *ngIf="archivo.estado === 'exito'"
          class="alert alert-success mx-3 my-2 text-center py-1"
          role="alert"
        >
          {{ archivo.mensaje }}
        </div>

        <div
          *ngIf="archivo.estado === 'error'"
          class="alert alert-danger mx-3 my-2 text-center py-1"
          role="alert"
        >
          {{ archivo.mensaje }}
        </div>

        <div class="card-footer d-flex justify-content-center gap-2">
          <button
            *ngIf="archivo.file"
            class="btn btn-success flex-grow-1"
            (click)="subirArchivo(archivo)"
          >
            Enviar Archivo
          </button>
          <button
            class="btn btn-primary flex-grow-1"
            (click)="descargarArchivo(archivo)"
          >
            Descargar
          </button>
          <button
            *ngIf="archivo.file"
            class="btn btn-danger flex-grow-1"
            (click)="removeFileCard(archivo)"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>

    <!-- Botones de acción globales -->
    <div class="col-12 mb-3" *ngIf="tieneArchivos()">
      <div class="d-flex gap-2 justify-content-end">
        <button class="btn btn-success" (click)="subirTodos()">
          <i class="icofont icofont-cloud-upload"></i> Subir Todos
        </button>
        <button class="btn btn-warning" (click)="limpiarCompletados()">
          <i class="icofont icofont-check"></i> Limpiar Completados
        </button>
        <button class="btn btn-danger" (click)="limpiarTodo()">
          <i class="icofont icofont-trash"></i> Limpiar Todo
        </button>
      </div>
    </div>
  </div>
</div>
